import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

const API_KEY_STORAGE_KEY = 'demo_esign_api_key';

@Injectable({
  providedIn: 'root'
})
export class EsignApiKeyService {

  private readonly apiKeySubject =
    new BehaviorSubject<string>(this.readStoredApiKey());

  get apiKey(): string {
    return this.apiKeySubject.value;
  }

  get hasApiKey(): boolean {
    return !!this.apiKey;
  }

  get maskedApiKey(): string {
    const key = this.apiKey;

    if (!key) {
      return '';
    }

    if (key.length <= 10) {
      return key;
    }

    return `${key.slice(0, 6)}••••${key.slice(-4)}`;
  }

  get changes(): Observable<string> {
    return this.apiKeySubject.asObservable();
  }

  save(apiKey: string): void {
    const normalizedKey = (apiKey || '').trim();

    try {
      if (normalizedKey) {
        localStorage.setItem(API_KEY_STORAGE_KEY, normalizedKey);
      } else {
        localStorage.removeItem(API_KEY_STORAGE_KEY);
      }
    } catch {
      // Private browsing / storage disabled: keep the key in memory only.
    }

    this.apiKeySubject.next(normalizedKey);
  }

  clear(): void {
    this.save('');
  }

  private readStoredApiKey(): string {
    try {
      const storedKey = localStorage.getItem(API_KEY_STORAGE_KEY);

      if (storedKey && storedKey.trim()) {
        return storedKey.trim();
      }
    } catch {
      // Ignore storage access errors and fall back to the environment key.
    }

    return (environment.esignApiKey || '').trim();
  }
}
